import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { install as installTelemetry } from './telemetry';
import './styles.css';

/**
 * Mövzu seçimini ƏN ƏVVƏL tətbiq edirik.
 *
 * ⚠️ React render olunana qədər. Sonra etsək, istifadəçi «Qaranlıq» seçsə
 * də səhifə bir an işıqlı yanıb-sönərdi — bu, ucuz görünüşün klassik
 * əlamətidir.
 */
const savedTheme = localStorage.getItem('mailora.theme');
if (savedTheme === 'dark' || savedTheme === 'light') {
  document.documentElement.setAttribute('data-theme', savedTheme);
}

// Tutucular React-dən ƏVVƏL qurulur — render zamanı baş verən xəta da tutulsun.
installTelemetry();

const root = document.getElementById('root');
if (!root) throw new Error('#root tapılmadı');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
